type UserInfoLike = {
  displayName?: string | null
  name?: string | null
  givenName?: string | null
  familyName?: string | null
  email?: string | null
}

export const resolveDisplayName = (userInfo?: UserInfoLike | null): string | null => {
  if (!userInfo) return null
  return (
    userInfo.displayName ||
    userInfo.name ||
    [userInfo.givenName, userInfo.familyName].filter(Boolean).join(' ') ||
    userInfo.email ||
    null
  )
}
